export default __webpack_public_path__ + "static/media/loanpal_pro_screen@2x.1455fb18.png";